import { EndpointReponseProps } from "../../types";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
// const baseURL = "http://localhost:8085/api";

export const Endpoints = {
     GetCheckServerHealth: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/health`,
               method: "GET",
          };
     },

     /**
      * Authentication Routes
      */
     GetLogin: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/login`,
               method: "POST",
          };
     },
     GetVerifyLoginOtp: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/verify-login-otp`,
               method: "POST",
          };
     },
     GetResendLoginOtp: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/resend-login-otp`,
               method: "POST",
          };
     },
     GetVerifyTwoFactorLogin: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/verify-2fa-login`,
               method: "POST",
          };
     },
     GetRegister: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/register`,
               method: "POST",
          };
     },
     GetVerifyEmail: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/verify-email`,
               method: "GET",
          };
     },
     GetResendVerificationEmail: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/resend-verification-email`,
               method: "POST",
          };
     },
     GetProfile: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/profile`,
               method: "GET",
          };
     },
     GetUpdateBasicProfile: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/update-basic-profile`,
               method: "PUT",
          };
     },
     GetUpdatePassword: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/change-password`,
               method: "POST",
          };
     },
     GetFetchProfileByBvn: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/fetch-profile-by-bvn`,
               method: "POST",
          };
     },
     GetUpdateProfile: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/profile`,
               method: "PUT",
          };
     },
     GetUpdateName: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/update-name`,
               method: "PUT",
          };
     },
     GetInitializeBvnConsent: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/v/initialize`,
               method: "POST",
          };
     },
     GetCompleteBvnConsent: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/v/complete`,
               method: "PUT",
          };
     },
     GetMatchBvnImage: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/v/match-image`,
               method: "POST",
          };
     },

     /**
      * KYC Submission
      */
     GetSubmitIdentityDocument: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/kyc/identity`,
               method: "POST",
          };
     },
     GetSubmitProofOfAddress: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/kyc/proof-of-address`,
               method: "POST",
          };
     },
     GetSubmitProofOfEmployment: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/kyc/proof-of-employment`,
               method: "POST",
          };
     },
     GetSubmitFinancialDocuments: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/kyc/financial-document`,
               method: "POST",
          };
     },
     GetSubmitNextOfKin: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/kyc/next-of-kin`,
               method: "POST",
          };
     },
     GetKycStatus: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/kyc/status`,
               method: "GET",
          };
     },

     /**
      * Loan Routes
      */
     GetApplyForLoan: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/loans/request`,
               method: "POST",
          };
     },
     GetLoanHistory: (page: number, limit: number): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/loans/history?page=${page}&limit=${limit}`,
               method: "GET",
          };
     },
     GetRepaymentVirtualAccount: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/loans/repayment/virtual-account`,
               method: "GET",
          };
     },
     InitiateCardRepayment: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/loans/repayment/card`,
               method: "POST",
          };
     },
     GetAvailableLoanPlans: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/loans`,
               method: "GET",
          };
     },
     GetNotifications: (limit = 25): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/notifications?limit=${limit}`,
               method: "GET",
          };
     },
     MarkNotificationsAsRead: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/notifications/mark-read`,
               method: "PATCH",
          };
     },
     /**
      * Upload a file to the server
      */
     GetUploadFile: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/files/upload`,
               method: "POST",
          };
     },
     GetBanks: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/banks`,
               method: "GET",
          };
     },
     GetResolveAccount: (
          accountNumber: string,
          bankCode: string
     ): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/resolve-account?accountNumber=${accountNumber}&bankCode=${bankCode}`,
               method: "GET",
          };
     },
     GetSetBankAccount: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/set-bank-account`,
               method: "POST",
          };
     },
     GetConfirmDirectDebitMandate: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/confirm-direct-debit-mandate`,
               method: "POST",
          };
     },
     GetRetryDirectDebitMandate: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/retry-direct-debit-mandate`,
               method: "POST",
          };
     },

     GetVerifyDirectDebitMandate: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/verify-direct-debit-mandate`,
               method: "POST",
          };
     },

     GetRetryDirectDebitActivation: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/auth/retry-direct-debit-activation`,
               method: "POST",
          };
     },

     /**
      * Two-Factor Authentication Routes
      */
     GetTwoFactorGenerateSecret: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/two-factor/generate`,
               method: "POST",
          };
     },
     GetTwoFactorEnable: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/two-factor/enable`,
               method: "POST",
          };
     },
     GetTwoFactorDisable: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/two-factor/disable`,
               method: "POST",
          };
     },
     GetTwoFactorStatus: (): EndpointReponseProps => {
          return {
               route: `${baseURL}/user/two-factor/status`,
               method: "GET",
          };
     },
};
